import React from 'react';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ApplicationForm from '../../components/Apply/ApplicationForm';
import './Apply.css';
import { useNavigate } from 'react-router-dom';

export default function Apply() {
  const navigate = useNavigate();
  return (
    <div>
      <Header />
      <Navbar />
      <main style={{ padding: 36 }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <button
              className="btn-secondary"
              onClick={() => navigate(-1)}
              style={{ padding: '6px 10px', display: 'inline-flex', alignItems: 'center', gap: 8 }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Retour
            </button>
            <h1 style={{ color: '#4b004b', fontSize: '28px', margin: 0 }}>Postuler chez Nexus Solutions</h1>
          </div>
          <p style={{ color: '#374151', marginBottom: 18 }}>Remplissez le formulaire ci-dessous pour postuler. Vous pouvez joindre votre CV (PDF / DOCX) et une lettre de motivation. Toutes les informations sont obligatoires.</p>
          <ApplicationForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}
